









































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Editor } from '@tiptap/core';
import { QuestionLanguage } from '@/resource/subject/subject.model';

@Component({
  components: {},
})
export default class EditorLanguage extends Vue {
  @Prop({ required: true })
  editor: Editor;

  addEnglishSection() {
    this.editor &&
      this.editor
        .chain()
        .focus()
        .toggleLangEnglish()
        .run();
  }

  addMalaySection() {
    this.editor &&
      this.editor
        .chain()
        .focus()
        .toggleLangMalay()
        .run();
  }

  addEnglishMark() {
    this.editor &&
      this.editor
        .chain()
        .focus()
        .toggleLanguage(QuestionLanguage.english)
        .run();
  }

  addMalayMark() {
    this.editor &&
      this.editor
        .chain()
        .focus()
        .toggleLanguage(QuestionLanguage.malay)
        .run();
  }

  addMath() {
    this.editor &&
      this.editor
        .chain()
        .focus()
        .toggleMath()
        .run();
  }
}
